// Loads Google Analytics only after the user has accepted cookies.
// Requires REACT_APP_GA_ID to be set; otherwise this is a safe no-op.
const GA_ID = process.env.REACT_APP_GA_ID;
let loaded = false;

export function loadGoogleAnalytics() {
  if (loaded || !GA_ID) return;
  loaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID, { anonymize_ip: true });
}
